"use client";

import AngleDown from "@/icons/angleDown.svg";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";
import { getTranslation } from "@/i18n/get-translation";
import { getFeaturedFAQs } from "@/services/faq-service";
import React, { useEffect, useState } from "react";
import { IFaqsData, TFeatureFaqResponse } from "@/types/faq.type";
import Link from "next/link";

interface IFAQ {
  locale: string;
  displayCount?: number;
}

const FAQ: React.FC<IFAQ> = ({ locale, displayCount = Infinity }: IFAQ) => {
  const t = getTranslation(locale, "faqs");
  const [faqsData, setFaqsData] = useState<IFaqsData[]>([]);
  const getFaqsData = () => {
    getFeaturedFAQs('en').then((response: TFeatureFaqResponse) => {
      setFaqsData(response.data.attributes.faqs.data);
    });
  };
  useEffect(() => {
    getFaqsData();
  }, []);
  return (
    <section className="w-full">
      {faqsData.slice(0, displayCount).map((item: IFaqsData) => (
        <Disclosure
          key={`faq_${item.id}`}
          as="div"
          className="mb-3 flex flex-col w-full items-stretch justify-start rounded-2xl bg-primary-500 border-2 border-primary-400 px-7 py-5 text-left text-xl font-medium text-primary-800 focus:outline-none"
        >
          {({ open }) => (
            <>
              <DisclosureButton className="flex w-full items-center justify-between focus:outline-none bg-primary-500">
                <span className="text-left pr-4">{item.attributes.title}</span>
                <div
                  className={`bg-primary-400-25 rounded-full flex-[0_0_2.5rem] min-w-[2.5rem] h-10 flex items-center justify-center text-primary-700 transition ${
                    open && "rotate-180 bg-primary-700 text-white"
                  }`}
                >
                  <AngleDown
                    className={`w-4 mt-1 ${open && "mt-[0.125rem]"}`}
                  />
                </div>
              </DisclosureButton>
              <DisclosurePanel
                as="div"
                className="pt-4 pb-2 text-lg text-gray-800 text-left font-light  "
              >
                <span>
                  {item.attributes.short_description}{' '}
                  <Link href={`/${locale}/faq/${item.attributes.slug}`}
                  className="text-base text-primary-700 font-normal">
                    {t("readMore")}
                  </Link>
                </span>
              </DisclosurePanel>
            </>
          )}
        </Disclosure>
      ))}
    </section>
  );
};

export default FAQ;
